<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('VerticalLineTool', function() {
            return {
                // Descriptor for the tool
                group: 'Lines', category: 'Lines', icon: this.getIcon('vertical_line'),
                type: 'Segment',
                name: 'Vertical Line',
                hint: 'This hint will be shown on hover',
                data: [],     // Default data
                settings: {}, // Default settings
                mods: {
                    'Ray': {
                        // Rewrites the default setting fields
                        settings: { ray: true },
                        category: 'Lines',
                        icon: this.getIcon('vertical_ray'),
                        name: 'Vertical Ray'
                    },
                    'Arrow': {
                        // Rewrites the default setting fields
                        settings: { arrow: true },
                        category: 'Lines',
                        icon: this.getIcon('arrow'),
                        name: 'Vertical Arrow'
                    }
                }
            }
        }, s => s.ray ? 'Vertical Ray' : s.arrow ? 'Vertical Arrow' : 'Vertical Line')
</script>
